import React from 'react';
import Scenes from '../../../components/scenes/scenes';
import styles from './home.module.scss';
import StarList from '../starList/starList';
import StarInstruction from '../starInstruction/starInstruction';
import { Switch, Redirect, Route, Link, withRouter } from 'react-router-dom';
class Home extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={styles.mHome}>
        <Switch>
          <Redirect exact from='/m' to={{pathname: '/m/scenes', search: window.location.search}} />
          <Route exact path="/m/scenes" component={Scenes} />
          <Route exact path="/m/starList" component={StarList} />
          <Route exact path="/m/starInstruction" component={StarInstruction} />
          <Route render={() => (<p style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translateX(-50%) translateY(-50%)', fontSize: '50px', color: '#ccc' }} >404</p>)} />
        </Switch>
      </div>
    )
  }
}
export default Home;